import { render, staticRenderFns } from "./error_pay.vue?vue&type=template&id=3a2e7dca&scoped=true"
import script from "./error_pay.vue?vue&type=script&lang=js"
export * from "./error_pay.vue?vue&type=script&lang=js"
import style0 from "./error_pay.vue?vue&type=style&index=0&id=3a2e7dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e7dca",
  null
  
)

export default component.exports